module.exports = __webpack_public_path__ + "img/ico-registration-phone.2f2b749b.png";